import React, { memo } from "react";
import { SvgIcon } from "@mui/material";

interface MobileDeviceIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const MobileDeviceIcon: React.FC<MobileDeviceIconProps> = ({
  className,
  width = 24,
  height = 24,
}) => {
  return (
    <SvgIcon className={className} style={{ width, height }} viewBox="0 0 83 139" fill="none">
      <path
        d="M60.2437 3.59961H22.481C12.0531 3.59961 3.59961 13.4314 3.59961 25.5596V113.4C3.59961 125.528 12.0531 135.36 22.481 135.36H60.2437C70.6716 135.36 79.1251 125.528 79.1251 113.4V25.5596C79.1251 13.4314 70.6716 3.59961 60.2437 3.59961Z"
        stroke="currentColor"
        strokeWidth="7.2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
};

export default memo(MobileDeviceIcon);
